/* =============================================
   CUSTOM MEGA MENU — JavaScript (Fixed Hover)
   File: assets/custom-mega-menu.js
   ============================================= */

(function () {
  // Overlay element banao
  const overlay = document.createElement('div');
  overlay.className = 'mega-menu-overlay';
  document.body.appendChild(overlay);

  const triggers = document.querySelectorAll('.mega-menu-trigger');
  let timeoutId = null; // Timer ko track karne ke liye global variable

  // Function: Sabhi dropdowns ko band karne ke liye
  function closeAll() {
    triggers.forEach(btn => {
      btn.setAttribute('aria-expanded', 'false');
      const id = btn.getAttribute('aria-controls');
      const dropdown = document.getElementById(id);
      if (dropdown) dropdown.classList.remove('is-open');
    });
    overlay.classList.remove('is-active');
  }

  // Function: Kisi specific menu ko open karne ke liye
  function openMenu(trigger, dropdown) {
    // Pehle se chal rahe kisi bhi close-timer ko cancel karo
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
    
    // Baaki saare dropdowns band karo taaki ek baar me ek hi khule
    triggers.forEach(btn => {
      if (btn !== trigger) {
        btn.setAttribute('aria-expanded', 'false');
        const id = btn.getAttribute('aria-controls');
        const db = document.getElementById(id);
        if (db) db.classList.remove('is-open');
      }
    });

    if (dropdown) {
      trigger.setAttribute('aria-expanded', 'true');
      dropdown.classList.add('is-open');
      overlay.classList.add('is-active');
    }
  }

  // Function: Delay ke saath band karne ke liye
  function startCloseTimeout(trigger, dropdown) {
    // Agar pehle se koi timer chal raha hai toh use clear karo
    if (timeoutId) clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      // Check karo ki cursor sach me dono se bahar hai ya nahi
      if (dropdown && !dropdown.matches(':hover') && !trigger.matches(':hover')) {
        closeAll();
      }
    }, 250); // 250ms ka safe delay taaki gap cross ho sake
  }

  triggers.forEach(trigger => {
    const id = trigger.getAttribute('aria-controls');
    const dropdown = document.getElementById(id);

    // --- TRIGGER EVENTS ---
    trigger.addEventListener('mouseenter', function (e) {
      e.stopPropagation();
      openMenu(trigger, dropdown);
    });

    trigger.addEventListener('mouseleave', function () {
      startCloseTimeout(trigger, dropdown);
    });

    // --- DROPDOWN EVENTS ---
    if (dropdown) {
      dropdown.addEventListener('mouseenter', function () {
        openMenu(trigger, dropdown); // Maウス dropdown me aate hi timer clear ho jayega
      });

      dropdown.addEventListener('mouseleave', function () {
        startCloseTimeout(trigger, dropdown);
      });
    }
  });
 
  // Bahar click karne par band ho
  document.addEventListener('click', function (e) {
    // Agar click trigger ya dropdown par nahi hua hai tabhi band karein
    if (!e.target.closest('.mega-menu-trigger') && !e.target.closest('.mega-menu-dropdown')) {
      closeAll();
    }
  });

  // Overlay click par bhi band ho
  overlay.addEventListener('click', function () {
    closeAll();
  });

  // ESC key se band ho
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeAll();
    }
  });
})();
